export default "__VITE_ASSET__20520004__"